/* eslint-disable max-len */
import * as React from "react";

interface SVGRProps {
    title?: string;
    titleId?: string;
}

function Search({ title, titleId, ...props }: React.SVGProps<SVGSVGElement> & SVGRProps) {
    return (
        <svg
            viewBox="0 0 18 18"
            width="1em"
            height="1em"
            role="img"
            aria-label={titleId ? undefined : "search"}
            aria-labelledby={titleId || undefined}
            {...props}
        >
            {title ? <title id={titleId}>{title}</title> : null}
            <path
                fill="#ADADAD"
                d="M7.885.19a7.695 7.695 0 016.124 12.355l3.623 3.86a.81.81 0 01-1.101 1.183l-.08-.075-3.556-3.787A7.695 7.695 0 117.885.19zm0 1.62a6.075 6.075 0 100 12.15 6.075 6.075 0 000-12.15z"
            />
        </svg>
    );
}

export default Search;
